export const contact = {
  is: {
    title: "Hafðu samband",
    description: "Við erum ávallt tilbúin að aðstoða þig og svara öllum þínum spurningum",
    form: {
      personalInfo: "Upplýsingar",
      name: "Nafn",
      email: "Netfang",
      phone: "Sími",
      company: "Fyrirtæki",
      subject: "Efni",
      message: "Skilaboð",
      submit: "Senda skilaboð"
    },
    contact: {
      title: "Hafðu samband",
      phone: "Sími",
      email: "Netfang",
      locations: "Staðsetningar",
      openingHours: "Opnunartími",
      weekdays: "Mánudagur - Föstudagur",
      weekdaysHours: "9:00 - 17:00",
      weekend: "Helgar",
      weekendHours: "Lokað"
    }
  },
  en: {
    title: "Contact Us",
    description: "We are always ready to assist you and answer all your questions",
    form: {
      personalInfo: "Information",
      name: "Name",
      email: "Email",
      phone: "Phone",
      company: "Company",
      subject: "Subject",
      message: "Message",
      submit: "Send Message"
    },
    contact: {
      title: "Contact Information",
      phone: "Phone",
      email: "Email",
      locations: "Locations",
      openingHours: "Opening Hours",
      weekdays: "Monday - Friday",
      weekdaysHours: "9:00 - 17:00",
      weekend: "Weekends",
      weekendHours: "Closed"
    }
  },
  es: {
    title: "Contáctanos",
    description: "Siempre estamos listos para ayudarte y responder todas tus preguntas",
    form: {
      personalInfo: "Información",
      name: "Nombre",
      email: "Correo electrónico",
      phone: "Teléfono",
      company: "Empresa",
      subject: "Asunto",
      message: "Mensaje",
      submit: "Enviar Mensaje"
    },
    contact: {
      title: "Información de Contacto",
      phone: "Teléfono",
      email: "Correo electrónico",
      locations: "Ubicaciones",
      openingHours: "Horario de Atención",
      weekdays: "Lunes - Viernes",
      weekdaysHours: "9:00 - 17:00",
      weekend: "Fines de semana",
      weekendHours: "Cerrado"
    }
  },
  da: {
    title: "Kontakt Os",
    description: "Vi er altid klar til at hjælpe dig og besvare alle dine spørgsmål",
    form: {
      personalInfo: "Information",
      name: "Navn",
      email: "E-mail",
      phone: "Telefon",
      company: "Virksomhed",
      subject: "Emne",
      message: "Besked",
      submit: "Send Besked"
    },
    contact: {
      title: "Kontaktinformation",
      phone: "Telefon",
      email: "E-mail",
      locations: "Lokationer",
      openingHours: "Åbningstider",
      weekdays: "Mandag - Fredag",
      weekdaysHours: "9:00 - 17:00",
      weekend: "Weekender",
      weekendHours: "Lukket"
    }
  }
};